import type { FetchRequestArgs, FetchRequestReturn } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const readConversation = async <T extends Record<string, unknown>>({
  headers,
  domain,
  query,
  signal,
}: FetchRequestArgs & {
  // eslint-disable-next-line camelcase
  query: { board_id: string; contact_id: string };
}): Promise<FetchRequestReturn<T>> =>
  fetchRequest<T>({
    domain,
    endpoint: '/v2/messaging/conversation',
    headers,
    method: HTTPMethod.GET,
    query,
    signal,
  });
